import styled from 'styled-components';
import { color } from 'styles/Theme';

export const modalStyle = {
	maxWidth: '400px',
	padding: '2rem'
};

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	gap: 1rem;
`;

export const IconWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 64px;
	height: 64px;
	background: ${color.system.error}20;
	border-radius: 50%;

	svg {
		font-size: 2rem;
		color: ${color.system.error};
	}
`;

export const Title = styled.h3`
	margin: 0;
	color: ${color.interface.brown};
	font-size: 1.25rem;
`;

export const Message = styled.p`
	margin: 0;
	color: ${color.interface.darkGray};
	line-height: 1.5;

	strong {
		color: ${color.interface.brown};
	}
`;
